// domain/paymentbadge.ts — jumlah "perlu aksi" pembayaran per-peran untuk badge menu (💬).
// Additive: v18 surfacekan di Perlu Diperhatikan; badge menu = penanda cepat yang auto-turun saat dikerjakan.
import type { Role } from '@core/types';

export interface PayActionCounts {
  verif: number;         // ditandai LUNAS belum diverifikasi Finance
  refundPending: number; // refund menunggu verifikasi Finance
  overdue: number;       // piutang tempo jatuh tempo lewat (penagihan CS)
}

/**
 * Total item perlu-aksi untuk peran ini (keputusan Apo):
 * Finance = validasi (verif + refund) · CS = penagihan (overdue) · O/M/SPV = gabungan · lainnya = 0.
 */
export function paymentActionTotal(role: Role, c: PayActionCounts): number {
  const validasi = c.verif + c.refundPending;
  switch (role) {
    case 'Admin Finance': return validasi;
    case 'CS': return c.overdue;
    case 'Owner':
    case 'Manager':
    case 'SPV': return validasi + c.overdue;
    default: return 0; // Teknisi & lainnya: tak ada PR pembayaran
  }
}
